import { TemplateAvailabilityLevelTypes } from "@enums/template-availability-level-types";
import { SelectOption } from "@iddataweb/idw-common-ui/types";

export const templateAvailabilityLevelOptions: Array<SelectOption<TemplateAvailabilityLevelTypes>> = [
    {
        label: 'Global',
        value: TemplateAvailabilityLevelTypes.GLOBAL
    },
    {
        label: 'Organization',
        value: TemplateAvailabilityLevelTypes.ORGANIZATION
    },
    {
        label: 'Relying Party',
        value: TemplateAvailabilityLevelTypes.RELYING_PARTY
    }
]